import { OnSchedTemplates } from "../../OnSchedTemplates";

export const AddToast = (data, message) => {
  const elToastContainer = document.getElementById('onsched-full-calendar-toast-container');
  
  const mountToast = (elToast, toastId, toastData) => {
    elToast.innerHTML = OnSchedTemplates.CalendarToast(toastData);
    elToastContainer.appendChild(elToast);

    elToastContainer.scrollIntoView();

    document.querySelector(`#toast${toastId} i`)
      .onclick = () => elToast.remove();
    
    setTimeout(() => elToast.remove(), 8000);
  }

  if (data.error) {
    data.data.errors.map((error, i) => {
      const elToast = document.createElement('DIV');
      const toastId = new Date().getTime();
    
      elToast.className = 'onsched-full-calendar-toast';
      elToast.id = 'toast' + toastId;    

      elToast.classList.add('error');
      elToast.key = i;
  
      const toastData = {
        icon: 'times',
        title: 'Could not complete',
        message: error.error
      }

      mountToast(elToast, toastId, toastData);
    })
  }
  else {
    const elToast = document.createElement('DIV');
    const toastId = new Date().getTime();
  
    elToast.className = 'onsched-full-calendar-toast';
    elToast.id = 'toast' + toastId;    

    elToast.classList.add('success');
  
    const toastData = {
      icon: 'times',
      title: 'Success',
      message
    }
  
    mountToast(elToast, toastId, toastData);
  }
}
